import {instanceAxios} from "@/axios/axios";
import cookie from "js-cookie";

export default function changeEmail(newEmail) {
    return new Promise((resolve, reject) => {
        instanceAxios
            .post(
                'change-email',
                {
                    params: {
                        userToken: cookie.get('token')
                    },
                    values: newEmail
                }
            )
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                return reject(error)
            })
    })
}